// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XcNfK","questions":"styles_questions__14K3z","footer":"styles_footer__zrZhY"};